import { render, staticRenderFns } from "./rich-text.vue?vue&type=template&id=89d7e9ba&scoped=true"
import script from "./rich-text.vue?vue&type=script&lang=js"
export * from "./rich-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d7e9ba",
  null
  
)

export default component.exports